import { ResponsivePie } from "@nivo/pie";
import { Box, useTheme } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { tokens } from "../theme";
import { getDatoInterfoleacion } from "../services/graficos.services";

const TURNO_LABELS = {
  3: "1er Turno",
  4: "2do Turno",
  12: "3er Turno",
};

const normalizeTurno = (value) => {
  if (value === null || value === undefined || value === "") {
    return "Turno no definido";
  }

  if (typeof value === "number") {
    return TURNO_LABELS[value] || `Turno ${value}`;
  }

  const parsed = parseInt(value, 10);
  if (!Number.isNaN(parsed)) {
    return TURNO_LABELS[parsed] || `Turno ${parsed}`;
  }

  const raw = String(value).trim();
  const normalized = raw.toLowerCase();

  if (normalized.includes("primer")) {
    return "1er Turno";
  }

  if (normalized.includes("segundo")) {
    return "2do Turno";
  }

  if (normalized.includes("tercer")) {
    return "3er Turno";
  }

  return raw;
};

const InterfoliadoTurnoPie = ({ fecha }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const fetchInterfoliados = async () => {
      try {
        const response = await getDatoInterfoleacion(fecha);
        setRows(Array.isArray(response) ? response : []);
      } catch (error) {
        console.error("Error al obtener interfoliados por turno:", error);
        setRows([]);
      }
    };

    fetchInterfoliados();
  }, [fecha]);

  const chartData = useMemo(() => {
    const totalsByTurno = rows.reduce((acc, item) => {
      const turnoKey = normalizeTurno(item.turno ?? item.id_horario);
      const qty = parseInt(item.cantidad ?? item.total_cantidad ?? 0, 10) || 0;

      acc[turnoKey] = (acc[turnoKey] || 0) + qty;
      return acc;
    }, {});

    return Object.entries(totalsByTurno)
      .map(([label, value]) => ({ id: label, label, value }))
      .filter((entry) => entry.value > 0);
  }, [rows]);

  const totalInterfoliado = useMemo(
    () => chartData.reduce((sum, item) => sum + item.value, 0),
    [chartData]
  );

  return (
    <>
      <Box
        sx={{
          textAlign: "end",
          paddingRight: { xs: "25%", sm: "15%", md: "32%" },
          paddingTop: { xs: "20px", md: "0" },
          width: "100%",
          fontFamily: "sans-serif",
          alignContent: "flex-end !important",
        }}
      >
        <label
          style={{
            fontSize: "clamp(22px, 2.5vw, 25px)",
            padding: "5px",
          }}
        >
          Interfoliados:
        </label>

        <label
          style={{
            fontSize: "clamp(22px, 2.5vw, 25px)",
          }}
        >
          {totalInterfoliado}
        </label>
      </Box>

      <ResponsivePie
        data={chartData}
        theme={{
          axis: {
            domain: {
              line: {
                stroke: colors.grey[100],
              },
            },
            legend: {
              text: {
                fill: colors.grey[100],
              },
            },
            ticks: {
              line: {
                stroke: colors.grey[100],
                strokeWidth: 1,
              },
              text: {
                fill: colors.grey[100],
              },
            },
          },
          labels: {
            text: {
              fontSize: 20,
              fill: colors.grey[100],
            },
          },
          legends: {
            text: {
              fill: colors.grey[100],
            },
          },
        }}
        margin={{ top: 40, right: 55, bottom: 95, left: 55 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={3}
        activeOuterRadiusOffset={8}
        borderColor={{
          from: "color",
          modifiers: [["darker", 0.2]],
        }}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor={colors.grey[100]}
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: "color" }}
        enableArcLabels={true}
        arcLabelsRadiusOffset={0.4}
        arcLabelsSkipAngle={7}
        arcLabelsTextColor={{
          from: "color",
          modifiers: [["darker", 2]],
        }}
        arcLabels={({ datum }) => `${datum.value}`}
        colors={["#00876c", "#f5950f", "#e43f5a", "#5f4bb6"]}
        tooltip={({ datum: { label, value, color } }) => (
          <div
            style={{
              padding: "12px",
              color,
              background: "#ffffff",
              border: "0.5px solid black",
            }}
          >
            <strong>
              {label} : {value}
            </strong>
          </div>
        )}
        legends={[
          {
            anchor: "bottom",
            direction: "row",
            justify: false,
            translateX: 0,
            translateY: 56,
            itemsSpacing: 0,
            itemWidth: 78,
            itemHeight: 18,
            itemTextColor: "#999",
            itemDirection: "left-to-right",
            itemOpacity: 1,
            symbolSize: 18,
            symbolShape: "circle",
            effects: [
              {
                on: "hover",
                style: {
                  itemTextColor: "#ffffff",
                },
              },
            ],
          },
        ]}
      />
    </>
  );
};

export default InterfoliadoTurnoPie;